import React from 'react'
import '../../css/ErrorBoundary.scss'

export default function ErrorBoundaryFallback() {
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className="error-boundary" role="alert">
      <div className="error-boundary-content">
        <h1>Something went wrong</h1>
        <p>An unexpected error occurred. Please refresh the page.</p>
        <button
          className="refresh-button"
          onClick={handleRefresh}
          type="button"
        >
          Refresh Page
        </button>
      </div>
    </div>
  )
}

